import React, { ReactNode } from 'react';
import { List } from '@material-ui/core';

import styles from './BeneficiaryTable.module.scss';

interface IBeneficiaryTable {
  children: ReactNode;
}

const BeneficiaryTable = ({ children }: IBeneficiaryTable) => (
  <List className={styles.container} disablePadding>
    {children}
  </List>
);

export default BeneficiaryTable;
